// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"PropertyIdDigitalTab_saveButton__2IVab","ModalDialog":"PropertyIdDigitalTab_ModalDialog__364SS"};